import { render } from "./EventEditView.vue?vue&type=template&id=f2c91e2c"
import script from "./EventEditView.vue?vue&type=script&lang=js"
export * from "./EventEditView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__